import { Match, MediaSource, CodeEventGroup, MatchEvent, Button, ButtonSet } from '../../models';
import { IFileImporter } from '../IFileConverter';
import * as functions from '../../common/functions';

export class LongoFileConverter implements IFileImporter {
  public name = 'LongoMatch';

  static processButtonConfiguration(dashboard: any): ButtonSet {
    console.info(`buttons: begin`);
    if (dashboard !== undefined && dashboard !== null) {
      console.info(`buttons: got a dashboard`);
      const events = (dashboard.List as any[]).map(e => {
        if (e.EventType !== undefined && e.EventType.$id) {
          const identifier = e.EventType.$id;

          console.info(`[processButtonConfiguration]:: ${identifier}`);

          return {
            identifier: identifier,
            eventType: e.Name,
            color: 'blue',
            leadSeconds: e.Start / 1000,
            lagSeconds: e.Stop / 1000
          } as Button;
        }
      }) as Button[];

      console.info(events);
      const buttonConfiguration = events.filter(e => e !== undefined);

      return {
        name: '',
        userId: '',
        buttons: buttonConfiguration
      };
    }

    return {} as ButtonSet;
  }

  static processCodedEvents(timeline: any, buttons: Button[]): CodeEventGroup[] {
    if (timeline !== undefined && timeline !== null) {
      console.info(`found timeline: ${timeline.length}`);
      const codedEventTypes = [] as CodeEventGroup[];

      const events = (timeline as any[]).forEach(e => {
        console.info(`Looking for ${e.EventType.$ref}`);

        const identifier = functions.getTimestamp();

        const btns = buttons.filter(b => {
          try {
            return b.identifier.toString() === e.EventType.$ref.toString();
          } catch (e) {
            console.log(e);
            //
          }
          return false;
        });

        if (btns !== undefined && btns[0] !== undefined) {
          const btn = btns[0];
          console.log(btn);
          console.info(`found button: ${btn.eventType}`);
          let item = codedEventTypes.find(codedEvent => codedEvent.eventType === btn.eventType);

          if (item === null || item === undefined) {
            item = {
              eventType: btn.eventType,
              events: []
            } as CodeEventGroup;

            codedEventTypes.push(item);
          }

          const s = e.EventTime / 1000 - btn.leadSeconds;
          item.events.push({
            identifier,
            eventType: btn.eventType,
            color: btn.color,
            leadSeconds: 5,
            lagSeconds: 5,
            seconds: Math.max(s, 0)
          } as MatchEvent);
        } else {
          console.info(`button was undefined`);
        }
      });

      console.info(codedEventTypes);
      return codedEventTypes.filter(e => e !== undefined);
    }

    console.info(`no coded events types found`);
    return [] as CodeEventGroup[];
  }

  static processProperties(metadata: any): Match {
    if (metadata !== undefined && metadata !== null) {
      const match = {
        competitionName: '',
        awayTeam: metadata.VisitorName,
        homeTeam: metadata.LocalName,
        grade: metadata.Competition,
        year: metadata.Season,
        matchName: metadata.Description,
        matchDate: metadata.MatchDate,
        roundNumber: 0,
        venue: '',
        userId: '',
        media: {} as MediaSource,
        identifier: '',
        buttonSetId: null,
        isPublished: false,
        isCurrentPublished: false,
        events: []
      } as Match;

      return match;
    }

    return {} as Match;
  }

  public convert(input: string): Match {
    const json = JSON.parse(input) as any;
    const match = LongoFileConverter.processProperties(json.Description);

    const buttonSet = LongoFileConverter.processButtonConfiguration(json.Dashboard);
    console.info(`got ${buttonSet.buttons.length} buttons`);
    const events = LongoFileConverter.processCodedEvents(json.Timeline, buttonSet.buttons);
    console.info(`got ${events.length} events`);

    match.events = events;
    return match;
  }
}
